import axios from 'axios';

const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

/**
 * Crée une instance Axios authentifiée avec le token de l'espace courant.
 * Le paramètre `_ent` est conservé pour compatibilité ascendante mais ignoré —
 * le token est toujours lu depuis le cookie `current_apiToken`.
 */
export const createAxiosEntrepriseInstance = (_ent) => {
    const instance = axios.create({
        baseURL: process.env.REACT_APP_API_URL,
    });

    instance.interceptors.request.use(
        config => {
            const token = getCookie('current_apiToken');
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        error => Promise.reject(error)
    );

    instance.interceptors.response.use(
        response => response,
        async (error) => {
            if (error.response && error.response.status === 401) {
                const errorMessage = error.response.data?.message;
                if (errorMessage === "Unauthenticated.") {
                    handleUnauthorized();
                }
            }
            return Promise.reject(error);
        }
    );

    return instance;
};

const handleUnauthorized = () => {
    window.location.href = '/';
};
